import { useEffect } from 'react';
import { useBreadcrumb } from './useBreadcrumb';

/**
 * Registers a human-readable label for a route param segment (e.g. accountId → account name).
 * Cleans up the label when the component unmounts.
 */
export function useBreadcrumbLabel(segment: string | undefined, label: string | undefined): void {
  const { setLabel, clearLabel } = useBreadcrumb();

  useEffect(() => {
    if (!segment || !label) return;
    setLabel(segment, label);
    return () => clearLabel(segment);
  }, [segment, label, setLabel, clearLabel]);
}
